import * as React from "react";

interface IconRapidProps {
  className?: string;
}

const IconRapid = ({ className }: IconRapidProps) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M6.65 8.38h-4.5a.54.54 0 01-.54-.53c0-.31.25-.54.54-.54h4.5c.31 0 .55.25.55.54 0 .28-.24.53-.55.53zM6.5 15.9H2.29a.54.54 0 01-.54-.53c0-.31.25-.54.54-.54h4.2c.32 0 .55.25.55.54 0 .3-.23.53-.54.53zM5.84 12.13H.7a.54.54 0 01-.54-.53c0-.31.25-.54.54-.54h5.14c.31 0 .54.25.54.54.02.3-.23.53-.54.53z"
          opacity="0.75"
        />
        <path d="M23.5 4.98c0 .35-.12.67-.3.94a9.38 9.38 0 00-2.56-2.2c.31-.28.72-.43 1.15-.43.95 0 1.7.75 1.7 1.7zM8.27 4.98c0 .35.11.67.29.94a9.37 9.37 0 012.56-2.2 1.75 1.75 0 00-1.15-.43c-.95 0-1.72.75-1.7 1.7z" />
        <path d="M24.15 10.17a8.27 8.27 0 00-6.77-6.7c-.71-.14-.75-.28-.7-1l.02-.2h1.36c.37-.02.55-.15.58-.48.04-.37.04-.77 0-1.2-.02-.15-.1-.42-.44-.42h-2.3c-.79 0-1.52 0-2.24.02-.31 0-.53.23-.54.56v.75c0 .56.23.77.8.77h1.39l.02.2c.07.7.04.84-.66.95-.06 0-.12.02-.18.04l-.15.04a8.26 8.26 0 00-5.3 3.48 8.04 8.04 0 00-1.3 6.15 8.3 8.3 0 009.97 6.54 8.31 8.31 0 006.44-9.5zm-3.41 6.21a6.77 6.77 0 01-4.77 1.99h-.06a6.84 6.84 0 01-6.8-6.85c0-3.67 3.07-6.7 6.84-6.7h.04a6.75 6.75 0 014.75 11.56z" />
        <path d="M17.03 12.46a1.37 1.37 0 01-1.94.21 1.37 1.37 0 01-.23-1.94c.14-.17.33-.33.52-.4l.02-2.75c0-.14.06-.27.16-.37.1-.1.23-.15.37-.15.29 0 .52.23.52.54l-.02 2.7c.14.07.25.12.35.2.3.23.49.56.53.92.05.39-.04.75-.28 1.04z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h24.44v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconRapid;
